// import axios from 'axios';

// const api = axios.create({
//     baseURL: 'http://localhost:8080/TRAITS-PMS-OLD/TRAITS-PMS/backend/api',  //Local baseURL
//     // baseURL: 'https://pms.traitsolutions.in/backend/api',  /Live base URL
// });

// // 🔁 Automatically attach token to all requests
// api.interceptors.request.use(
//     (config) => {
//         const token = localStorage.getItem('token');
//         if (token) {
//             config.headers.Authorization = `Bearer ${token}`;
//         }
//         return config;
//     },
//     (error) => Promise.reject(error)
// );

// // ⚠️ Handle 401 Unauthorized globally
// api.interceptors.response.use(
//     (response) => response,
//     (error) => {
//         if (error.response && error.response.status === 401) {
//             localStorage.removeItem('token');
//             localStorage.removeItem('user');
//             window.location.href = '/';
//         }
//         return Promise.reject(error);
//     }
// );

// // ✅ Authentication
// export const login = async (username, password) => {
//     try {
//         const response = await api.post('/auth.php', { username, password });
//         return response;
//     } catch (error) {
//         console.error('Error during login:', error);
//         return { data: {} };  // Fallback in case of error
//     }
// };

// // ✅ Owners
// export const createOwner = async (data) => {
//     try {
//         const response = await api.post('/lease.php', data);
//         return response;
//     } catch (error) {
//         console.error('Error creating owner:', error);
//         return { data: {} };
//     }
// };

// export const getOwners = async () => {
//     try {
//         const response = await api.get('/lease.php');
//         return response;
//     } catch (error) {
//         console.error('Error fetching owners:', error);
//         return { data: [] };  // Return an empty array in case of error
//     }
// };

// // ✅ Leases
// export const createLease = async (formData) => {
//     try {
//         const response = await api.post('/lease.php', formData, {
//             headers: { 'Content-Type': 'multipart/form-data' },
//         });
//         return response;
//     } catch (error) {
//         console.error('Error creating lease:', error);
//         return { data: {} };
//     }
// };

// export const getLeases = async (ownerId) => {
//     try {
//         const response = await api.get(`/lease.php?owner_id=${ownerId}`);
//         return response;
//     } catch (error) {
//         console.error('Error fetching leases for owner:', error);
//         return { data: [] };
//     }
// };

// export const renewLease = async (leaseId) => {
//     try {
//         const response = await api.put('/lease.php', { lease_id: leaseId });
//         return response;
//     } catch (error) {
//         console.error('Error renewing lease:', error);
//         return { data: {} };
//     }
// };

// // ✅ Properties
// export const createProperty = async (data) => {
//     try {
//         const response = await api.post('/property.php', data);
//         return response;
//     } catch (error) {
//         console.error('Error creating property:', error);
//         return { data: {} };
//     }
// };

// export const getProperties = async () => {
//     try {
//         const response = await api.get('/property.php');
//         return response;
//     } catch (error) {
//         console.error('Error fetching properties:', error);
//         return { data: [] };
//     }
// };

// export const getPropertyDetails = async (propertyId) => {
//     try {
//         const response = await api.get(`/property.php?property_id=${propertyId}`);
//         return response;
//     } catch (error) {
//         console.error('Error fetching property details:', error);
//         return { data: {} };
//     }
// };

// // ✅ Tenants
// export const createTenant = async (data) => {
//     try {
//         const response = await api.post('/tenant.php', data);
//         return response;
//     } catch (error) {
//         console.error('Error creating tenant:', error);
//         return { data: {} };
//     }
// };

// export const getTenants = async () => {
//     try {
//         const response = await api.get('/tenant.php');
//         return response;
//     } catch (error) {
//         console.error('Error fetching tenants:', error);
//         return { data: [] };
//     }
// };

// export const getTenantDetails = async (tenantId) => {
//     try {
//         const response = await api.get(`/tenant.php?tenant_id=${tenantId}`);
//         return response;
//     } catch (error) {
//         console.error('Error fetching tenant details:', error);
//         return { data: {} };
//     }
// };

// // ✅ Rent
// export const assignTenant = async (data) => {
//     try {
//         const response = await api.post('/rent.php', data);
//         return response;
//     } catch (error) {
//         console.error('Error assigning tenant:', error);
//         return { data: {} };
//     }
// };

// export const getAssignments = async () => {
//     try {
//         const response = await api.get('/rent.php');
//         return response;
//     } catch (error) {
//         console.error('Error fetching assignments:', error);
//         return { data: [] };
//     }
// };

// export const enterRent = async (data) => {
//     try {
//         const response = await api.post('/rent.php', {
//             action: 'rent_entry',
//             data: JSON.stringify(data),
//         });
//         return response;
//     } catch (error) {
//         console.error('Error entering rent:', error);
//         return { data: {} };
//     }
// };

// export const getCollectionList = async () => {
//     try {
//         const response = await api.get('/rent.php?view=collection_list');
//         return response;
//     } catch (error) {
//         console.error('Error fetching collection list:', error);
//         return { data: [] };
//     }
// };

// export const getCollectionEntries = async () => {
//     try {
//         const response = await api.get('/rent.php?view=collection_entries');
//         return response;
//     } catch (error) {
//         console.error('Error fetching collection entries:', error);
//         return { data: [] };
//     }
// };

// export const getApprovals = async () => {
//     try {
//         const response = await api.get('/rent.php?view=approvals');
//         return response;
//     } catch (error) {
//         console.error('Error fetching approvals:', error);
//         return { data: [] };
//     }
// };

// export const collectPayment = async (paymentId) => {
//     try {
//         const response = await api.put('/rent.php', { action: 'collect', payment_id: paymentId });
//         return response;
//     } catch (error) {
//         console.error('Error collecting payment:', error);
//         return { data: {} };
//     }
// };

// export const approvePayment = async (paymentId) => {
//     try {
//         const response = await api.put('/rent.php', { action: 'approve', payment_id: paymentId });
//         return response;
//     } catch (error) {
//         console.error('Error approving payment:', error);
//         return { data: {} };
//     }
// };

// // ✅ Cheques
// export const addCheque = async (data) => {
//     try {
//         const response = await api.post('/cheque.php', data);
//         return response;
//     } catch (error) {
//         console.error('Error adding cheque:', error);
//         return { data: {} };
//     }
// };

// export const getCheques = async () => {
//     try {
//         const response = await api.get('/cheque.php');
//         return response;
//     } catch (error) {
//         console.error('Error fetching cheques:', error);
//         return { data: [] };
//     }
// };

// export const getChequeDetails = async (chequeId) => {
//     try {
//         const response = await api.get(`/cheque.php?cheque_id=${chequeId}`);
//         return response;
//     } catch (error) {
//         console.error('Error fetching cheque details:', error);
//         return { data: {} };
//     }
// };

// export const updateChequeStatus = async (chequeId, status) => {
//     try {
//         const response = await api.put('/cheque.php', { cheque_id: chequeId, status });
//         return response;
//     } catch (error) {
//         console.error('Error updating cheque status:', error);
//         return { data: {} };
//     }
// };

// // ✅ Bulk Cheque Upload
// export const bulkUploadCheques = async (formData) => {
//     try {
//         const response = await api.post('/cheque.php', formData, {
//             headers: { 'Content-Type': 'multipart/form-data' },
//         });
//         return response;
//     } catch (error) {
//         console.error('Error bulk uploading cheques:', error);
//         return { data: {} };
//     }
// };

// // ✅ Logout helper
// export const logout = () => {
//     localStorage.removeItem('token');
//     localStorage.removeItem('user');
//     window.location.href = '/';
// };

// // ✅ Grouped exports for modular usage
// export const authAPI = { login, logout };
// export const ownerAPI = { createOwner, getOwners };
// export const leaseAPI = { createLease, getLeases, renewLease };
// export const rentAPI = {
//     assignTenant,
//     enterRent,
//     getAssignments,
//     getCollectionList,
//     getCollectionEntries,
//     getApprovals,
//     collectPayment,
//     approvePayment,
// };
// export const tenantAPI = { createTenant, getTenants, getTenantDetails };
// export const propertyAPI = { createProperty, getProperties, getPropertyDetails };
// export const chequeAPI = { addCheque, getCheques, getChequeDetails, updateChequeStatus, bulkUploadCheques };

// // ✅ Dashboard Data (Additional Example)
// export const getDashboardData = async (monthFilter) => {
//     try {
//         const response = await api.get(`/dashboard.php?month=${monthFilter}`);
//         return response.data;
//     } catch (error) {
//         console.error('Error fetching dashboard data:', error);
//         return { data: {} };
//     }
// };
// export const bulkUploadOwners = async (formData) => {
//     try {
//         const response = await api.post('/lease.php', formData, {
//             headers: { 'Content-Type': 'multipart/form-data' },
//         });
//         return response;
//     } catch (error) {
//         console.error('Bulk upload failed:', error);
//         return { data: {} };
//     }
// };



// // Example for bulk upload functions
// export const bulkUploadProperties = (data) => {
//     return propertyAPI.post('/bulk-upload', data);
//   };
  
//   export const bulkUploadAssignments = (data) => {
//     return rentAPI.post('/bulk-upload', data);
//   };
  
//   export const bulkUploadTenants = (data) => {
//     return tenantAPI.post('/bulk-upload', data);
//   };

  
// export default api;





import axios from 'axios';

const api = axios.create({
 //     baseURL: 'http://localhost:8080/TRAITS-PMS-OLD/TRAITS-PMS/backend/api',  //Local baseURL
 baseURL: 'https://pms.traitsolutions.in/backend/api',  
});

// 🔁 Automatically attach token to all requests
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// ⚠️ Handle 401 Unauthorized globally
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.href = '/';
        }
        return Promise.reject(error);
    }
);

// ✅ Authentication
export const login = async (username, password) => {
    try {
        const response = await api.post('/auth.php', { username, password });
        return response;
    } catch (error) {
        console.error('Error during login:', error);
        return { data: {} };  // Fallback in case of error
    }
};

// ✅ Owners
export const createOwner = async (data) => {
    try {
        const response = await api.post('/lease.php', data);
        return response;
    } catch (error) {
        console.error('Error creating owner:', error);
        return { data: {} };
    }
};

export const getOwners = async () => {
    try {
        const response = await api.get('/lease.php');
        return response;
    } catch (error) {
        console.error('Error fetching owners:', error);
        return { data: [] };  // Return an empty array in case of error
    }
};

// ✅ Leases
export const createLease = async (formData) => {
    try {
        const response = await api.post('/lease.php', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response;
    } catch (error) {
        console.error('Error creating lease:', error);
        return { data: {} };
    }
};

export const getLeases = async (ownerId) => {
    try {
        const response = await api.get(`/lease.php?owner_id=${ownerId}`);
        return response;
    } catch (error) {
        console.error('Error fetching leases for owner:', error);
        return { data: [] };
    }
};

export const renewLease = async (leaseId) => {
    try {
        const response = await api.put('/lease.php', { lease_id: leaseId });
        return response;
    } catch (error) {
        console.error('Error renewing lease:', error);
        return { data: {} };
    }
};

// ✅ Properties
export const createProperty = async (data) => {
    try {
        const response = await api.post('/property.php', data);
        return response;
    } catch (error) {
        console.error('Error creating property:', error);
        return { data: {} };
    }
};

export const getProperties = async () => {
    try {
        const response = await api.get('/property.php');
        return response;
    } catch (error) {
        console.error('Error fetching properties:', error);
        return { data: [] };
    }
};

export const getPropertyDetails = async (propertyId) => {
    try {
        const response = await api.get(`/property.php?property_id=${propertyId}`);
        return response;
    } catch (error) {
        console.error('Error fetching property details:', error);
        return { data: {} };
    }
};

// ✅ Tenants
export const createTenant = async (data) => {
    try {
        const response = await api.post('/tenant.php', data);
        return response;
    } catch (error) {
        console.error('Error creating tenant:', error);
        return { data: {} };
    }
};

export const getTenants = async () => {
    try {
        const response = await api.get('/tenant.php');
        return response;
    } catch (error) {
        console.error('Error fetching tenants:', error);
        return { data: [] };
    }
};

export const getTenantDetails = async (tenantId) => {
    try {
        const response = await api.get(`/tenant.php?tenant_id=${tenantId}`);
        return response;
    } catch (error) {
        console.error('Error fetching tenant details:', error);
        return { data: {} };
    }
};

// ✅ Rent
export const assignTenant = async (data) => {
    try {
        const response = await api.post('/rent.php', data);
        return response;
    } catch (error) {
        console.error('Error assigning tenant:', error);
        return { data: {} };
    }
};

export const getAssignments = async () => {
    try {
        const response = await api.get('/rent.php');
        return response;
    } catch (error) {
        console.error('Error fetching assignments:', error);
        return { data: [] };
    }
};

export const enterRent = async (data) => {
    try {
        const response = await api.post('/rent.php', {
            action: 'rent_entry',
            data: JSON.stringify(data),
        });
        return response;
    } catch (error) {
        console.error('Error entering rent:', error);
        return { data: {} };
    }
};

export const getCollectionList = async () => {
    try {
        const response = await api.get('/rent.php?view=collection_list');
        return response;
    } catch (error) {
        console.error('Error fetching collection list:', error);
        return { data: [] };
    }
};

export const getCollectionEntries = async () => {
    try {
        const response = await api.get('/rent.php?view=collection_entries');
        return response;
    } catch (error) {
        console.error('Error fetching collection entries:', error);
        return { data: [] };
    }
};

export const getApprovals = async () => {
    try {
        const response = await api.get('/rent.php?view=approvals');
        return response;
    } catch (error) {
        console.error('Error fetching approvals:', error);
        return { data: [] };
    }
};

export const collectPayment = async (paymentId) => {
    try {
        const response = await api.put('/rent.php', { action: 'collect', payment_id: paymentId });
        return response;
    } catch (error) {
        console.error('Error collecting payment:', error);
        return { data: {} };
    }
};

export const approvePayment = async (paymentId) => {
    try {
        const response = await api.put('/rent.php', { action: 'approve', payment_id: paymentId });
        return response;
    } catch (error) {
        console.error('Error approving payment:', error);
        return { data: {} };
    }
};

// ✅ Cheques
export const addCheque = async (data) => {
    try {
        const response = await api.post('/cheque.php', data);
        return response;
    } catch (error) {
        console.error('Error adding cheque:', error);
        return { data: {} };
    }
};

export const getCheques = async () => {
    try {
        const response = await api.get('/cheque.php');
        return response;
    } catch (error) {
        console.error('Error fetching cheques:', error);
        return { data: [] };
    }
};

export const getChequeDetails = async (chequeId) => {
    try {
        const response = await api.get(`/cheque.php?cheque_id=${chequeId}`);
        return response;
    } catch (error) {
        console.error('Error fetching cheque details:', error);
        return { data: {} };
    }
};

export const updateChequeStatus = async (chequeId, status) => {
    try {
        const response = await api.put('/cheque.php', { cheque_id: chequeId, status });
        return response;
    } catch (error) {
        console.error('Error updating cheque status:', error);
        return { data: {} };
    }
};

// ✅ Bulk Cheque Upload
export const bulkUploadCheques = async (formData) => {
    try {
        const response = await api.post('/cheque.php', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response;
    } catch (error) {
        console.error('Error bulk uploading cheques:', error);
        return { data: {} };
    }
};

// ✅ Logout helper
export const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/';
};

// ✅ Grouped exports for modular usage
export const authAPI = { login, logout };
export const ownerAPI = { createOwner, getOwners };
export const leaseAPI = { createLease, getLeases, renewLease };
export const rentAPI = {
    assignTenant,
    enterRent,
    getAssignments,
    getCollectionList,
    getCollectionEntries,
    getApprovals,
    collectPayment,
    approvePayment,
};
export const tenantAPI = { createTenant, getTenants, getTenantDetails };
export const propertyAPI = { createProperty, getProperties, getPropertyDetails };
export const chequeAPI = { addCheque, getCheques, getChequeDetails, updateChequeStatus, bulkUploadCheques };

// ✅ Dashboard Data (Additional Example)
export const getDashboardData = async (monthFilter) => {
    try {
        const response = await api.get(`/dashboard.php?month=${monthFilter}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching dashboard data:', error);
        return { data: {} };
    }
};
export const bulkUploadOwners = async (formData) => {
    try {
        const response = await api.post('/lease.php', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response;
    } catch (error) {
        console.error('Bulk upload failed:', error);
        return { data: {} };
    }
};



// Example for bulk upload functions
export const bulkUploadProperties = (data) => {
    return propertyAPI.post('/bulk-upload', data);
  };
  
  export const bulkUploadAssignments = (data) => {
    return rentAPI.post('/bulk-upload', data);
  };
  
  export const bulkUploadTenants = (data) => {
    return tenantAPI.post('/bulk-upload', data);
  };

  
export default api;